module.exports = __webpack_public_path__ + "img/rightarrow.d7702e7c.svg";